export default import.meta.ROLLUP_FILE_URL_KZ5uZxzuNXFzz58FSOQTLw